import { Loader2, AlertCircle, RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import type { MAXAuthStatus } from "@/hooks/useMAXAuth";

interface MAXAuthGateProps {
  status: MAXAuthStatus;
  error: string | null;
  onRetry: () => void;
}

export function MAXAuthGate({ status, error, onRetry }: MAXAuthGateProps) {
  if (status === "idle" || status === "success") return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-background/80 backdrop-blur-xl"
      role="status"
      aria-live="polite"
    >
      <div className="w-full max-w-sm rounded-2xl border border-border/50 bg-card/90 p-6 shadow-2xl backdrop-blur-2xl">
        {status === "verifying" && (
          <div className="flex flex-col items-center gap-4 text-center">
            <Loader2 className="h-10 w-10 animate-spin text-primary" aria-hidden />
            <div>
              <h2 className="text-lg font-semibold text-foreground">
                Проверка авторизации MAX
              </h2>
              <p className="mt-1 text-sm text-muted-foreground">
                Подождите, проверяем безопасное подключение…
              </p>
            </div>
          </div>
        )}

        {status === "error" && (
          <div className="flex flex-col gap-4">
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" aria-hidden />
              <AlertTitle>Ошибка авторизации</AlertTitle>
              <AlertDescription>
                {error ?? "Не удалось войти через MAX. Попробуйте ещё раз."}
              </AlertDescription>
            </Alert>
            <Button onClick={onRetry} className="w-full" variant="default">
              <RefreshCw className="mr-2 h-4 w-4" aria-hidden />
              Повторить
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
